import { DecimalPipe } from "@angular/common";
import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { DatepickerComponent } from "@components/datepicker/datepicker.component";
import { InputComponent } from "@components/input/input.component";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { IKundorderDetailKundorder } from "~app/features/forsaljning/kundorder/models/kundorder-detail-model";
import { ICopyOrderHeader } from "../copy-order.models";

@Component({
    selector: "rask-copy-order-header",
    templateUrl: "./copy-order-header.component.html",
    styleUrls: ["./copy-order-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        DatepickerComponent,
        DecimalPipe
    ]
})
export class CopyOrderHeaderComponent implements OnInit {
    form: UntypedFormGroup;
    @Input() kundorder: IKundorderDetailKundorder;
    @Input() orderHeader: ICopyOrderHeader;
    @Input() rootForm: UntypedFormGroup;
    validation: IValidationScope;
    @Input() validationContext: IValidationContext;

    private readonly formBinder = inject(FormBinderService);

    ngOnInit(): void {
        this.setupForm();
    }

    private setupForm(): void {
        this.form = this.formBinder.CreateGroup(this.orderHeader);
        this.rootForm.addControl("copy-order-header", this.form);

        this.form.valueChanges.subscribe(() => {
            this.validationContext.validate();
        });

        this.validationContext.scope(ValidationScopes.skapa).subscribe(v => {
            this.validation = v;
        });

        this.formBinder.attachValidation(this.validationContext.current, this.form);

        this.validationContext.validate();
    }
}
